module.exports = __webpack_public_path__ + "img/dlz-office.395fe854.png";